import {
  formatAppTitle,
  getDefaultOgImageUrl,
  getSiteOrigin,
  SITE_DEFAULT_DESCRIPTION,
  SITE_NAME,
  SITE_TAGLINE,
} from '../config/siteBranding';
import { getCanonicalSiteOrigin } from './canonicalOrigin';

const DEFAULT_META = {
  title: SITE_NAME,
  description: SITE_DEFAULT_DESCRIPTION,
  image: getDefaultOgImageUrl(),
  url: getSiteOrigin(),
};

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function resolveShareImage(image) {
  if (!image || typeof image !== 'string' || !image.trim()) {
    return getDefaultOgImageUrl();
  }
  const trimmed = image.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }
  if (trimmed.startsWith('/')) {
    return `${getCanonicalSiteOrigin()}${trimmed}`;
  }
  return trimmed;
}

/** Update document title and Open Graph / Twitter tags for link previews (WhatsApp, Facebook, etc.) */
export function setPageMeta({ title, description, image, url } = {}) {
  const resolvedTitle = title || DEFAULT_META.title;
  const resolvedDescription = description || DEFAULT_META.description;
  const resolvedImage = resolveShareImage(image);
  const resolvedUrl = url || DEFAULT_META.url;

  document.title = resolvedTitle;

  upsertMeta('name', 'description', resolvedDescription);
  upsertMeta('property', 'og:site_name', SITE_NAME);
  upsertMeta('property', 'og:title', resolvedTitle);
  upsertMeta('property', 'og:description', resolvedDescription);
  upsertMeta('property', 'og:image', resolvedImage);
  upsertMeta('property', 'og:image:width', '1200');
  upsertMeta('property', 'og:image:height', '630');
  upsertMeta('property', 'og:url', resolvedUrl);
  upsertMeta('property', 'og:type', 'article');
  upsertLink('canonical', resolvedUrl);
  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', resolvedTitle);
  upsertMeta('name', 'twitter:description', resolvedDescription);
  upsertMeta('name', 'twitter:image', resolvedImage);
}

export function resetPageMeta() {
  setPageMeta({
    title: SITE_NAME,
    description: SITE_DEFAULT_DESCRIPTION,
    image: getDefaultOgImageUrl(),
    url: getSiteOrigin(),
  });
}

export function getDefaultBlogListMeta(categoryLabel) {
  const title = categoryLabel && categoryLabel !== 'All posts'
    ? `${categoryLabel} | ${SITE_NAME}`
    : formatAppTitle('Blog');
  return {
    title,
    description: `${SITE_TAGLINE}. Read guides on diet, training, sports, and family outings.`,
    image: getDefaultOgImageUrl(),
    url: `${getSiteOrigin()}/blog`,
  };
}
